import Creator from "./Creator";
import Checker from "./Checker";

export default class AddonList {
    private creator: Creator;

    private ids: number[];
    private options: number[];

    public constructor(creator: Creator) {
        this.creator = creator;

        this.ids = [];
        this.options = [];
    }

    public addMain(ids: number[]): void {
        for (let id of ids) {
            this.ids.push(id);
        }
    }

    public addOption(ids: number[]): void {
        for (let id of ids) {
            this.options.push(id);
        }
    }

    private updateHtml(): void {
        let main = AddonList.getClass(this.ids);
        let options = AddonList.getClass(this.options);

        let $main = $(main, this.creator.$el);
        let $options = $(options, this.creator.$el);

        AddonList.allCheck(this.creator, $main, $options);
    }

    private static getClass(ids: number[]): string {
        let cls = '';

        for (let id of ids) {
            if (cls != '') {
                cls += ', ';
            }

            cls += '.a-' + id + ' .xcheck';
        }

        return cls;
    }

    private static setChecked(checked: boolean, $els: JQuery): void {
        $els.filter(':visible').each((i, el) => {
            let $xcheck = $(el).data('xcheck');
            $xcheck.setChecked(checked);
        });
    }

    private static allCheck(creator: Creator, $main: JQuery, $options: JQuery): void {
        let $all = $main.add($options);

        creator.form.$bypass_checks = creator.form.$bypass_checks.add($all);

        $all.each((i, el) => {
            var $this = $(el);
            var check = new Checker($this);

            check.onChange((val: boolean, xcheck?: any) => {
                if (!creator.form.bypass_checkers) {
                    creator.form.bypass_checkers = true;

                    let $this: JQuery = xcheck.getElement();
                    let ismain = $main.filter($this).length > 0;

                    if (ismain) {
                        this.setChecked(val, $main);

                        if (!val) {
                            this.setChecked(false, $options);
                        }
                    } else {
                        if (val) {
                            this.setChecked(val, $main);
                        }
                    }

                    creator.updateVis();
                    creator.updateCart();

                    creator.form.bypass_checkers = false;
                }
            });
        });
    }

    public static create(creator: Creator, ids: number[], options?: number[]): AddonList {
        let list = new AddonList(creator);

        list.addMain(ids);

        if (options != null) {
            list.addOption(options);
        }

        list.updateHtml();

        return list;
    }
}
